import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '@styles/index';

const StyledAccordian = styled(MuiAccordion)`
  &.MuiAccordion-root {
    padding: ${({ padding }) =>
      padding || `${Spacings.SPACING_8B} ${Spacings.SPACING_10B}`};
    background-color: ${({ bgColor }) => bgColor || 'var(--color-base-1)'};
    box-shadow: ${boxShadowGenerator()};
    border-radius: 8px;
    margin: ${Spacings.SPACING_4B} 0;
    border: 2px solid transparent;

    &.Mui-expanded {
      border: ${({ $showExpandedBorder }) =>
        `2px solid ${
          $showExpandedBorder ? 'var(--color-divider)' : 'transparent'
        }`};
      transition: border-color 200ms ease;
    }

    &:before {
      content: none;
    }
  }
`;

const StyledAccordionSummary = styled(MuiAccordionSummary)`
  &.MuiAccordionSummary-root {
    padding: 0px;

    &.Mui-expanded {
      min-height: inherit;
      padding: 0px;
    }

    .MuiAccordionSummary-content {
      display: block;
      margin: 0px;

      &.Mui-expanded {
        margin: 0px;
      }
    }
  }
`;

const StyledAccordionDetails = styled(MuiAccordionDetails)`
  &.MuiAccordionDetails-root {
    display: block;
    padding: 0px;
  }
`;

const Accordion = ({
  children,
  showExpandedBorder,
  expanded,
  className,
  onClick,
  onEnteredHandler,
  role,
  disabled
}) => (
  <StyledAccordian
    $showExpandedBorder={showExpandedBorder}
    expanded={expanded}
    onChange={onClick}
    className={className}
    TransitionProps={{
      onEntered: onEnteredHandler
    }}
    role={role}
    disabled={disabled}
  >
    {children}
  </StyledAccordian>
);

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  showExpandedBorder: PropTypes.bool,
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
  onEnteredHandler: PropTypes.func,
  className: PropTypes.string,
  role: PropTypes.string,
  disabled: PropTypes.bool
};

Accordion.defaultProps = {
  showExpandedBorder: false,
  expanded: false,
  disabled: false,
  className: '',
  onClick: () => {},
  onEnteredHandler: () => {},
  role: ''
};

Accordion.Summary = StyledAccordionSummary;
Accordion.Details = StyledAccordionDetails;

export default Accordion;
